import React, { useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { sendSupportMsg } from "@actions/contact";
import RenderFormFieldNew from "@components/forms/RenderFormFieldNew";
import styled from "@emotion/styled";
import {
  subject,
  supportMessage
} from "@components/validation/supportCardLevelForm";
import CustomSubmitButton from "./CustomSubmitButton";

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  margin-top: 45px;
`;

const ServerError = styled.div`
  color: #ee5050;
  margin-bottom: 14px;
`;

const SupportForm = ({
  handleSubmit,
  orderAssistance,
  sendSupportMessage,
  invalid,
  setFinished
}) => {
  const [serverError, setServerError] = useState();

  const submit = async fields => {
    const supportResponse = await sendSupportMessage({
      name: orderAssistance.name,
      email: orderAssistance.email,
      orderId: orderAssistance.orderId,
      orderType: orderAssistance.orderType,
      subject: fields.subject,
      message: fields.message
    });
    if (supportResponse.error) {
      setServerError(supportResponse.error);
    } else if (supportResponse === "success") {
      setFinished(true);
    }
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <InputWrapper>
        <Field
          name="subject"
          component={RenderFormFieldNew}
          type="text"
          placeholder="Subject"
          validate={subject}
        />
      </InputWrapper>
      <InputWrapper>
        <Field
          name="message"
          component={RenderFormFieldNew}
          type="text"
          inputType={"textArea"}
          inputHeight={"200px"}
          placeholder="Please describe your issue in detail so we can assist you."
          topPlaceholder="Additional message"
          validate={supportMessage}
        />
      </InputWrapper>
      <ButtonContainer>
        {serverError && <ServerError>{serverError}</ServerError>}
        <CustomSubmitButton
          type="submit"
          styles={{ height: "72px", borderRadius: "36px" }}
          buttonType={"ORANGE_BUTTON"}
          appearDisabled={invalid}
        >
          Submit
        </CustomSubmitButton>
      </ButtonContainer>
    </form>
  );
};

export default connect(
  state => ({ orderAssistance: state.orderAssistance }),
  dispatch => ({
    sendSupportMessage: payload => dispatch(sendSupportMsg(payload))
  })
)(
  reduxForm({
    form: "support",
    enableReinitialize: true
  })(SupportForm)
);
